export default __webpack_public_path__ + "static/media/footer-twitter-icon.a62fdc05.png";